import { ReactNode } from "react";

type SectionCardProps = {
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
};

export const SectionCard = ({
  title,
  description,
  action,
  children,
}: SectionCardProps) => (
  <section className="space-y-4 rounded-lg border border-border bg-gray-800 p-4">
    <header className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div>
        <h2 className="text-xl font-semibold text-primary">{title}</h2>
        {description && <p className="text-sm text-gray-200">{description}</p>}
      </div>
      {action}
    </header>
    {children}
  </section>
);
